export function normalizeToStringId(id: string | number | null | undefined): string {
  if (typeof id === 'number') return id.toString();
  if (typeof id === 'string') return id;
  return '';
}
